import React from "react";

// Maps a normalized email status to a pill style, shared by the toolkit result
// tables. Unknown/other statuses fall back to the neutral "notfound" look.
const CLASS = {
  valid: "valid",
  enriched: "valid",
  risky: "risky",
  invalid: "invalid",
  blacklisted: "invalid",
  skipped: "skipped"
};

const StatusPill = ({ status }) => {
  if (!status) return "-";
  const cls = CLASS[status.toLowerCase()] || "notfound";
  return <span className={`dtStatusPill ${cls}`}>{status.replace(/_/g, " ")}</span>;
};

export default StatusPill;
